import React from 'react'
import EditButton from '../../buttons/EditButton'

const editButton = ({ rowData, navigateTo }) => {
  return (
    <div key={rowData?._id}>
      <EditButton
        onClick={() => navigateTo(rowData?._id, { state: { isEdit: true } })}
      />
    </div>
  )
}

const rowEditNavigatePath = ({ navigateTo }) => {
  return {
    className: 'row-delete',
    rowEditor: 'rowEditor',
    body: (rowData) => editButton({ rowData, navigateTo }),
    exportable: false,
  }
}

export default rowEditNavigatePath
